import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LiveLink } from '../../interfaces/live-link';

@Injectable({
  providedIn: 'root'
})
export class LiveLinkService {

  api: string = `${environment.api}/live`;

  constructor(private http: HttpClient){}

  getLink(){
    return this.http.get<LiveLink>(`${this.api}`, { observe: 'body' });
  }

  setLink(url: string, isLive: boolean){
    return this.http.post<string>(`${this.api}`, { url: url, is_live: isLive }, { observe: 'body' });
  }
}
